import React, { useState, useEffect } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import {
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  FormGroup,
  TextField,
  Typography,
} from "@mui/material";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import { InputAdornment, IconButton } from "@mui/material";
import { confirmUser } from "../../redux/actions/usersManagementActionCreators";
import { useParams, useHistory } from "react-router-dom";
import ControlPassword from "../../components/ControlPassword";

const ResetPassword = () => {
  const [showPassword, setShowPassword] = useState(false);
  const [showControl, setShowControl] = useState(false);
  const [checked, setChecked] = useState(false);
  const [error, setError] = useState(false);

  const params = useParams();
  const history = useHistory();

  useEffect(() => {
    // const confirmUser = document.getElementById('confirm-user')
    const confirmConfirmUser = document.getElementById("confirm-confirm-user");
    // confirmUser.onpaste = e => e.preventDefault()
    confirmConfirmUser.onpaste = (e) => e.preventDefault();
  }, []);

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const handleChecked = (value) => {
    setChecked(value);
    setError(!value);
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const { t } = useTranslation();

  const dispatch = useDispatch();

  const formik = useFormik({
    initialValues: {
      password: "",
      confirmPassword: "",
      termsAndConditions: false,
    },
    validationSchema: Yup.object({
      password: Yup.string()
        .max(255)
        .required(t("required_field"))
        .matches(
          /^(?=.{8,})(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[@#$%^&+=*?!-]).*$/,
          t("password_policy")
        ),
      confirmPassword: Yup.string()
        .oneOf([Yup.ref("password"), null], t("match_password"))
        .required(t("required_field")),
    }),
    onSubmit: (values) => {
      if (checked) {
        setError(false);
        dispatch(
          confirmUser(
            params.token,
            values.password,
            values.confirmPassword,
            checked,
            history
          )
        );
      } else {
        setError(true);
      }
    },
  });

  return (
    <>
      <Box>
        <h3>
          {t("you_are_invited")}
          <br /> {t("please_confirm")}
        </h3>
      </Box>
      <br></br>
      <Box component="main">
        <form onSubmit={formik.handleSubmit}>
          <div style={{ height: "130px" }}>
            <Typography variant="subtitle2">{t("password")}*</Typography>
            <TextField
              id="confirm-user"
              placeholder={t("password")}
              name="password"
              variant="outlined"
              fullWidth
              error={Boolean(formik.touched.password && formik.errors.password)}
              helperText={formik.touched.password && formik.errors.password}
              onBlur={(e) => {
                formik.handleBlur(e);
                setShowControl(false);
              }}
              onChange={formik.handleChange}
              onFocus={() => setShowControl(true)}
              value={formik.values.password}
              type={showPassword ? "text" : "password"}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={handleClickShowPassword}
                      onMouseDown={handleMouseDownPassword}
                      edge="end"
                      size="large"
                    >
                      {showPassword ? <Visibility /> : <VisibilityOff />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </div>
          {showControl && (
            <div style={{ marginTop: "-35px" }}>
              <ControlPassword value={formik.values.password} />
            </div>
          )}
          <div style={{ height: "130px" }}>
            <Typography variant="subtitle2">
              {t("confirm_password")}*
            </Typography>
            <TextField
              id="confirm-confirm-user"
              placeholder={t("confirm_password")}
              name="confirmPassword"
              variant="outlined"
              fullWidth
              error={Boolean(
                formik.touched.confirmPassword && formik.errors.confirmPassword
              )}
              helperText={
                formik.touched.confirmPassword && formik.errors.confirmPassword
              }
              onBlur={formik.handleBlur}
              onChange={formik.handleChange}
              value={formik.values.confirmPassword}
              type="password"
            />
          </div>
          <FormGroup>
            <FormControlLabel
              required
              control={
                <Checkbox
                  checked={checked}
                  onChange={(e) => handleChecked(e.target.checked)}
                  name="termsAndConditions"
                  error={true}
                />
              }
              label={
                <p>
                  {t("read_accept")}{" "}
                  <a
                    href="https://cytailor.io/service"
                    target="_blank"
                    id="register_link"
                  >
                    {t("cgu")}
                  </a>{" "}
                  {t("and")}{" "}
                  <a
                    href="https://cytailor.io/privacy"
                    target="_blank"
                    id="register_link"
                  >
                    {t("privacy_policy")}
                  </a>
                </p>
              }
            />
            {error && <p className="error-message">{t("error_message")}</p>}
          </FormGroup>
          <Box sx={{ py: 2 }}>
            <Button
              color="secondary"
              fullWidth
              size="large"
              type="submit"
              variant="contained"
            >
              {t("confirm_registration")}
            </Button>
          </Box>
        </form>
      </Box>
    </>
  );
};

export default ResetPassword;
